<template>
    <div class="holder">
        <section class="hero-holder hero-holder--tool tool-holder--postal-check">
            <div class="hero-container">
                <h3 class="subtitle hero__subtitle">Welkom bij de huisscan!</h3>
                <h2 class="title hero__title">Wat is jouw postcode?</h2>
                <div class="hero__text-holder">
                    <p>Je wil groener gaan wonen en wil weten of je kunt besparen. Start met de huisscan.</p>
                </div>
                <div class="inputfield-holder">
                    <div class="inputfield tool__errror">
                        <label for="zipcode" class="label">Postcode</label>
                        <input id="zipcode" type="text" minlength="6" maxlength="6" required placeholder="1111 AB" @keypress="handleSubmit($event)" v-model="store.zipCode" />
                        <span v-if="error.zipCode" class="error-text">ERROR!!!</span>
                    </div>
                    <div class="inputfield tool__errror">
                        <label for="housenumber" class="label">Huisnummer</label>
                        <input id="housenumber" minlength="1" type="number" required placeholder="00" @keypress="handleSubmit($event)" v-model="store.houseNumber" />
                        <span v-if="error.houseNumber" class="error-text">ERROR!!!</span>
                    </div>
                    <div class="inputfield tool__errror">
                        <label for="addition" class="label">Toevoeging</label>
                        <input id="addition" type="text" placeholder="A" @keypress="handleSubmit($event)" v-model="store.addition" />
                        <span v-if="error.addition" class="error-text">ERROR!!!</span>
                    </div>
                </div>
                <div class="postal-check__disclaimer">
                    <p>We maken gebruik van de gegevens van kadaster.nl. Wij zijn niet verantwoordelijk voor de correctheid deze gegevens.</p>
                </div>
                <div class="tool__btn-holder">
                    <div class="button" :disabled="(!store.zipcode && !store.houseNumber) || isLoading" @click="handleNextRoute()">Start de check</div>
                    <loader v-if="isLoading" />
                </div>
                <div class="tool__kadaster-error" v-if="error.kadaster.error">
                    <p>{{ error.kadaster.message }}</p>
                </div>
            </div>
            <div class="hero-image-holder">
                <svg class="hero-image__shape" width="600" height="808" viewBox="0 0 600 808" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M600 569.471L300 808L-4.01823e-05 569.471L1.04767e-05 -9.99999L600 -9.99994L600 569.471Z" fill="#60C1B6"/>
                </svg>
                <img class="hero-image__image" src="/media/images/tool/tool-hero-image.png" alt="Augenbroe Duurzaam" />
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';

import store from '../store/store';

import loader from './icons/loader';

export default {
    components: {
        loader
    },

    data() {
        return {
            store,
            error: {
                zipCode: false,
                houseNumber: false,
                addition: false,
                kadaster: {
                    error: false,
                    message: ''
                },
            },
            isLoading: false
        }
    },

    async mounted() {
        this.store.questionInfo = await axios.get('/api/questions/get-question')
            .then(response => {
                const data = response.data;
                this.populateAnswersArray(data);
                return data;
            });
        
        localStorage.setItem('toolInfo', JSON.stringify(this.store));
    },

    methods: {
        populateAnswersArray(data) {
            // Use this as grid for storing the answers
            for (let i = 0; i < data.length; i++) {
                const answers = {
                    answers: []
                }

                if (data[i].sideQuestions) {
                    const answersSideQeustion = {
                        answers: [],
                        sideQuestions: {
                            answers: []
                        }
                    }

                    for (let x = 0; x < data[i].sideQuestions.length; x++) {
                        answersSideQeustion.sideQuestions.answers.push([]);
                    }

                    this.store.questionAnswers.push(answersSideQeustion);
                    continue;
                }

                this.store.questionAnswers.push(answers);
            }
        },

        handleSubmit(e) {
            if (e.which !== 13) {
                return;
            }

            this.handleNextRoute();
        },

        async handleNextRoute() {
            if ((!this.store.zipcode && !this.store.houseNumber) || this.isLoading) {
                return;
            }

            this.isLoading = true;
            const apiUrl = this.store.addition ? `/api/kadaster/get-residence-data/${this.store.zipCode}/${this.store.houseNumber}/${this.store.addition}` : `/api/kadaster/get-residence-data/${this.store.zipCode}/${this.store.houseNumber}`;

            await axios.get(apiUrl)
                .then((response) => {
                    const data = response.data;
                    this.isLoading = false;

                    if (data.buildYear === undefined) {
                        // reset inputs
                        this.store.zipCode = '';
                        this.store.houseNumber = '';
                        this.store.addition = '';

                        // set error message
                        this.error.kadaster.error = true;
                        this.error.kadaster.message = 'Geen resultaten gevonden, check je gegevens en probeer opnieuw!';

                        return;
                    }

                    this.store.kadaster = data;
                    localStorage.setItem('toolInfo', JSON.stringify(this.store));

                    this.$router.push({
                        path: '/tool/woning-type'
                    });
                })
                .catch((error) => {
                    this.isLoading = false;

                    if (error.response.status === 500) {
                        this.error.kadaster.error = true;
                        this.error.kadaster.message = 'Check je ingevulde postcode en huisnummer, deze lijken niet te kloppen.';
                        console.error(`[Error occured]: ${error}`);
                        return;
                    }
                    // reset inputs
                    this.store.zipCode = '';
                    this.store.houseNumber = '';
                    this.store.addition = '';
                    // set error message
                    this.error.kadaster.error = true;
                    this.error.kadaster.message = 'Geen resultaten gevonden, check je gegevens en probeer opnieuw!';
                    // Log error message
                    console.error(`[Error occured]: ${error}`);
                });
        }
    }
}
</script>
